import { Options } from '.';

/* istanbul ignore file */
export class SchemaFieldProperty {
    enum?: string[];
    grid?: boolean;
    menuDisplayText?: string;
    options?: Options;
    photos?: boolean;
    required?: boolean;
    text?: string;
    type?: string;
    upload?: boolean;
    enableSubRow?: boolean;
}
